<template>
  <inventoryReportsList/>
</template>
<script>
import inventoryReportsList from '@/components/modules/inventory/reports/list'
export default {
  name: 'inventoryReports',
  components: {
    inventoryReportsList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/inventory/reports/list.vue